﻿// noinspection JSUnusedGlobalSymbols

import { Conversation, PartialOptions } from "@elevenlabs/client";
import { Cookies } from "typescript-cookie"

let Dotnet: any;
let conversation: Conversation | null;
let interval: any;
let offset = 0;
let bars: number[] = [];

const frameRateMs = 100;

interface ISettings {
    Muted: boolean;
    Volume: number;
}

let Settings: ISettings = LoadSettings();

async function Connect(url: string, overrides: any, dotnet: any, tools: string[]) {

    Dotnet = dotnet;

    // close any previous session cleanly
    if (conversation) {
        await Disconnect();
    }

    OnStatusChanged('Connecting');

    try {
        // get mic access
        await navigator.mediaDevices.getUserMedia({ audio: true });

        // start the session (this opens a new WebSocket under the hood)
        let configuration: PartialOptions = {

            signedUrl: url,

            overrides: {
                agent: {
                    prompt: {
                        prompt: overrides.prompt,
                    },
                    firstMessage: overrides.greeting,
                    language: overrides.language,
                },
                tts: {
                    voiceId: overrides.voice,
                }
            },

            clientTools: {

                present: (args) => {
                    Dotnet.invokeMethodAsync("OnPresent", args.message);
                    return "OK, it is now being prepared and will presented to the user in a about 10 seconds.";
                },
            },

            // Statuses
            onConnect: () => {
                OnStatusChanged("Listening");
                offset = 0;
                bars = [];
                interval = setInterval(() => {
                    if (offset + 5 >= bars.length) {
                        document.getElementById('h1')!.style.height = '5%';
                        document.getElementById('h2')!.style.height = '5%';
                        document.getElementById('h3')!.style.height = '5%';
                        document.getElementById('h4')!.style.height = '5%';
                        document.getElementById('h5')!.style.height = '5%';
                        return;
                    }

                    document.getElementById('h1')!.style.height = 0.3 * bars[offset] * Math.random() + '%';
                    document.getElementById('h2')!.style.height = 0.8 * bars[offset] * Math.random() + '%';
                    document.getElementById('h3')!.style.height = bars[offset] * Math.random() + '%';
                    document.getElementById('h4')!.style.height = 0.8 * bars[offset] * Math.random() + '%';
                    document.getElementById('h5')!.style.height = 0.3 * bars[offset] * Math.random() + '%';
                    offset++;
                }, frameRateMs);

            },
            onDisconnect: () => {
                OnStatusChanged("Disconnected")
                clearInterval(interval);
            }
            ,
            onModeChange: (mode) => {
                switch (mode.mode) {
                    case "speaking": OnStatusChanged("Speaking"); break;
                    case "listening":
                        OnStatusChanged("Listening");
                        offset = bars.length;
                        break;
                }
            },

            onError: err => {
                console.error("ElevenLabs Error:", err);
                conversation = null;
            },


            /*onTranscription: chunk => {
                if (chunk.isFinal) {
                    dotNetHelper.invokeMethodAsync("OnTranscription", transcription + chunk.text);
                    transcription = "";
                }
                else transcription += chunk.text;
            },*/
            onMessage: x => {
                let role = x.source.toLowerCase() == "user" ? "User" : "Assistant";
                Dotnet.invokeMethodAsync("OnMessage", role, x.message || "");
            },


            onUnhandledClientToolCall: _ => {

            },

            onStatusChange: prop => {
                switch (prop.status) {
                    case "connecting":
                        break;
                    case "connected":
                        break;
                    case "disconnecting":
                        break;
                    case "disconnected":
                        break;

                }
            },
            onAudio: audioString => {
                let bytesString = atob(audioString);
                let utf8Encode = new TextEncoder();
                let bytes = utf8Encode.encode(bytesString);
                let values = [];
                for (let i = 0; i < bytes.length; i++) {
                    let b1 = bytes[i];
                    i++;
                    let b2 = bytes[i];

                    let value = b2 * 255 + b1;
                    values.push(value);
                }

                let seconds = values.length / 24000;
                console.log(seconds + " seconds");

                let roundCount = 24000 * frameRateMs / 1000;
                for (let i = 0; i < values.length; i += roundCount) {
                    if (i + roundCount >= values.length) break;
                    let rms = 0;
                    for (let j = 0; j < roundCount; j++) {
                        if (values[i + j] > 30000) rms += 1;
                    }
                    rms /= roundCount;

                    if (rms > 0.6) rms = 1;
                    else rms = 0;


                    bars.push(100 * rms );
                }
                console.log(bars);
            }
        };

        configuration.clientTools = {};
        for (const tool of tools) configuration.clientTools[tool] = x => OnToolExecute(tool, x);

        conversation = await Conversation.startSession(configuration);
        window.ElevenLabsSession = conversation;

        OnStatusChanged('Listening');
    }
    catch (e) {

        if (url.includes(document.location.host)) {
            console.error(e);
            OnStatusChanged('Disconnected');
            return null;
        }
        console.warn("Reconnecting to proxy.");
        return await Connect("wss://" + document.location.host + "/elevenlabs?url=" + encodeURIComponent(url), overrides, dotnet, tools)
    }

    try {
        SetMuted(Settings.Muted);
        SetVolume(Settings.Volume);
    }
    catch (e) {
        console.error(e);
    }
    return conversation.getId();
}

function LoadSettings(): ISettings {
    try {
        const value = Cookies.get("eleven-labs-agent-settings");
        if (!value) return { Muted: false, Volume: 1 };
        return JSON.parse(value.toString());
    }
    catch (e) {
        console.error(e);
        return { Muted: false, Volume: 1 };
    }
}
function SaveSettings() { Cookies.set("eleven-labs-agent-settings", JSON.stringify(Settings), { expires: 999 }); }

function OnToolExecute(name: string, args: any): Promise<string> {
    console.log("[Tool] " + name);
    return Dotnet.invokeMethodAsync("OnToolExecute", name, JSON.stringify(args));
}

function OnStatusChanged(status: string) {
    console.log("[Status] " + status);
    Dotnet.invokeMethodAsync("OnStatusChanged", status);
}

function SetMuted(muted: boolean) {
    Settings.Muted = muted;
    try {
        conversation?.setMicMuted(muted);
        SaveSettings();
    }
    catch (e) {
        console.error(e);
    }
}

function GetMuted(): boolean {
    return Settings.Muted;
}

function GetVolume(): number {
    return Settings.Volume;
}

function SetVolume(volume: number) {
    Settings.Volume = volume;
    try {
        conversation?.setVolume({ volume: volume });
        SaveSettings();
    }
    catch (e) {
        console.error(e);
    }
}

async function Disconnect(): Promise<void> {
    if (!conversation) return;

    try {
        conversation?.endSession();
    }
    catch (e) {
        console.error(e);
    }
    conversation = null;
    OnStatusChanged('Disconnected');
}

declare global {
    interface Window {
        ElevenLabsSession?: any;
    }
}

export const ElevenLabsVoiceAgent = {
    Connect,
    Disconnect,
    GetMuted,
    SetMuted,
    GetVolume,
    SetVolume
}